import React, { useState } from 'react';
import { Settings, Users, CreditCard, Bell, Check, Mail, Smartphone, Shield, Building, Globe, Download, Plus, MoreHorizontal } from 'lucide-react';
export function SettingsGeneral() {
  return <div className="space-y-6 max-w-4xl" data-id="element-2562">
      <div data-id="element-2563">
        <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2564">
          Impostazioni generali
        </h1>
        <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-2565">
          Gestisci le preferenze del tuo account e le informazioni aziendali.
        </p>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl p-6" data-id="element-2566">
        <h3 className="text-base font-semibold text-[#FAFAFA] font-heading mb-4" data-id="element-2567">
          Profilo Aziendale
        </h3>
        <div className="space-y-4" data-id="element-2568">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2569">
            <div data-id="element-2570">
              <label className="block text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-1.5" data-id="element-2571">
                Nome Azienda
              </label>
              <input type="text" defaultValue="Aisac S.p.A." className="w-full px-3 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-2572" />
            </div>
            <div data-id="element-2573">
              <label className="block text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-1.5" data-id="element-2574">
                Partita IVA
              </label>
              <input type="text" defaultValue="IT01234567890" className="w-full px-3 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] font-mono focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-2575" />
            </div>
          </div>
          <div data-id="element-2576">
            <label className="block text-[10px] uppercase tracking-wider text-[#6B6B6B] font-medium mb-1.5" data-id="element-2577">
              Indirizzo Sede Legale
            </label>
            <input type="text" defaultValue="Via Roma 123, 20100 Milano (MI)" className="w-full px-3 py-2.5 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-2578" />
          </div>
        </div>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl p-6" data-id="element-2579">
        <h3 className="text-base font-semibold text-[#FAFAFA] font-heading mb-4" data-id="element-2580">
          Preferenze Piattaforma
        </h3>
        <div className="space-y-4" data-id="element-2581">
          <div className="flex items-center justify-between gap-4" data-id="element-2582">
            <div data-id="element-2583">
              <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2584">Lingua</div>
              <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2585">
                Lingua dell'interfaccia per il tuo account
              </div>
            </div>
            <select className="px-3 py-2 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-2586">
              <option data-id="element-2587">Italiano</option>
              <option data-id="element-2588">English</option>
            </select>
          </div>
          <div className="flex items-center justify-between gap-4 pt-4 border-t border-[#262626]" data-id="element-2589">
            <div data-id="element-2590">
              <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2591">
                Fuso orario
              </div>
              <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2592">
                Fuso orario utilizzato per date e orari
              </div>
            </div>
            <select className="px-3 py-2 rounded-lg bg-[#0A0A0A] border border-[#262626] text-sm text-[#FAFAFA] focus:outline-none focus:border-[#D4FF3A]/40" data-id="element-2593">
              <option data-id="element-2594">Europe/Rome (UTC+1)</option>
              <option data-id="element-2595">Europe/London (UTC+0)</option>
            </select>
          </div>
        </div>
      </div>

      <div className="flex justify-end" data-id="element-2596">
        <button className="px-4 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-2597">
          Salva modifiche
        </button>
      </div>
    </div>;
}
export function SettingsTeam() {
  const TEAM = [{
    name: 'Mario Rossi',
    email: 'mario.rossi@aisac.io',
    role: 'Admin',
    status: 'Attivo'
  }, {
    name: 'Giulia Bianchi',
    email: 'giulia.b@aisac.io',
    role: 'Operatore',
    status: 'Attivo'
  }, {
    name: 'Luca Verdi',
    email: 'luca.v@aisac.io',
    role: 'Operatore',
    status: 'In attesa'
  }];
  return <div className="space-y-6 max-w-5xl" data-id="element-2598">
      <div className="flex items-end justify-between flex-wrap gap-3" data-id="element-2599">
        <div data-id="element-2600">
          <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2601">
            Team
          </h1>
          <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-2602">
            Gestisci gli accessi e i ruoli dei membri del tuo team.
          </p>
        </div>
        <button className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg bg-[#D4FF3A] text-[#0A0A0A] text-sm font-semibold hover:bg-[#c2ed28] transition" data-id="element-2603">
          <Plus className="h-4 w-4" data-id="element-2604" />
          Invita membro
        </button>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-2605">
        <table className="w-full text-sm text-left" data-id="element-2606">
          <thead className="text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#262626] bg-[#0A0A0A]" data-id="element-2607">
            <tr data-id="element-2608">
              <th className="px-5 py-3 font-medium" data-id="element-2609">Utente</th>
              <th className="px-5 py-3 font-medium" data-id="element-2610">Ruolo</th>
              <th className="px-5 py-3 font-medium" data-id="element-2611">Stato</th>
              <th className="px-5 py-3 font-medium w-8" data-id="element-2612"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#262626]" data-id="element-2613">
            {TEAM.map((member, i) => <tr key={i} className="hover:bg-[#0A0A0A] transition-colors" data-id="element-2614">
                <td className="px-5 py-4" data-id="element-2615">
                  <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2616">
                    {member.name}
                  </div>
                  <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2617">
                    {member.email}
                  </div>
                </td>
                <td className="px-5 py-4" data-id="element-2618">
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-[#262626] text-[#FAFAFA]" data-id="element-2619">
                    {member.role}
                  </span>
                </td>
                <td className="px-5 py-4" data-id="element-2620">
                  <span className={`inline-flex items-center gap-1.5 text-xs ${member.status === 'Attivo' ? 'text-[#D4FF3A]' : 'text-[#F5A524]'}`} data-id="element-2621">
                    <span className={`h-1.5 w-1.5 rounded-full ${member.status === 'Attivo' ? 'bg-[#D4FF3A]' : 'bg-[#F5A524]'}`} data-id="element-2622" />
                    {member.status}
                  </span>
                </td>
                <td className="px-5 py-4 text-right" data-id="element-2623">
                  <button className="p-1 rounded text-[#6B6B6B] hover:text-[#FAFAFA] hover:bg-[#262626] transition" data-id="element-2624">
                    <MoreHorizontal className="h-4 w-4" data-id="element-2625" />
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}
export function SettingsBilling() {
  return <div className="space-y-6 max-w-4xl" data-id="element-2626">
      <div data-id="element-2627">
        <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2628">
          Fatturazione
        </h1>
        <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-2629">
          Gestisci il tuo piano, i metodi di pagamento e le fatture.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2630">
        <div className="bg-[#181818] border border-[#262626] rounded-xl p-6" data-id="element-2631">
          <div className="flex items-center justify-between mb-4" data-id="element-2632">
            <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-2633">
              Piano attuale
            </h3>
            <span className="px-2 py-0.5 rounded text-[10px] uppercase tracking-wider font-semibold bg-[#D4FF3A]/10 text-[#D4FF3A] border border-[#D4FF3A]/30" data-id="element-2634">
              Pro
            </span>
          </div>
          <div className="text-3xl font-mono font-semibold text-[#FAFAFA] mb-1" data-id="element-2635">
            € 299
            <span className="text-sm text-[#6B6B6B] font-sans font-normal" data-id="element-2636">
              /mese
            </span>
          </div>
          <p className="text-xs text-[#9A9A9A] mb-6" data-id="element-2637">
            Fino a 5.000 spedizioni/mese. Rinnovo automatico il 01/06/2026.
          </p>
          <button className="w-full px-4 py-2 rounded-lg bg-[#262626] text-[#FAFAFA] text-sm font-medium hover:bg-[#333] transition" data-id="element-2638">
            Gestisci piano
          </button>
        </div>

        <div className="bg-[#181818] border border-[#262626] rounded-xl p-6" data-id="element-2639">
          <h3 className="text-base font-semibold text-[#FAFAFA] font-heading mb-4" data-id="element-2640">
            Metodo di pagamento
          </h3>
          <div className="flex items-center gap-4 p-3 rounded-lg border border-[#262626] bg-[#0A0A0A] mb-6" data-id="element-2641">
            <div className="h-8 w-12 bg-white rounded flex items-center justify-center shrink-0" data-id="element-2642">
              <CreditCard className="h-5 w-5 text-black" data-id="element-2643" />
            </div>
            <div className="min-w-0" data-id="element-2644">
              <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2645">
                Mastercard terminante in 4242
              </div>
              <div className="text-xs text-[#9A9A9A]" data-id="element-2646">Scade 12/28</div>
            </div>
          </div>
          <button className="w-full px-4 py-2 rounded-lg bg-[#262626] text-[#FAFAFA] text-sm font-medium hover:bg-[#333] transition" data-id="element-2647">
            Aggiorna metodo
          </button>
        </div>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-2648">
        <div className="px-6 py-4 border-b border-[#262626]" data-id="element-2649">
          <h3 className="text-base font-semibold text-[#FAFAFA] font-heading" data-id="element-2650">
            Storico fatture
          </h3>
        </div>
        <ul className="divide-y divide-[#262626]" data-id="element-2651">
          {[{
          date: '01 Mag 2026',
          amount: '€ 299,00',
          status: 'Pagato',
          id: 'INV-2026-05'
        }, {
          date: '01 Apr 2026',
          amount: '€ 299,00',
          status: 'Pagato',
          id: 'INV-2026-04'
        }, {
          date: '01 Mar 2026',
          amount: '€ 299,00',
          status: 'Pagato',
          id: 'INV-2026-03'
        }].map(inv => <li key={inv.id} className="px-6 py-4 flex items-center justify-between gap-4" data-id="element-2652">
              <div data-id="element-2653">
                <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2654">
                  {inv.date}
                </div>
                <div className="text-xs font-mono text-[#6B6B6B] mt-0.5" data-id="element-2655">
                  {inv.id}
                </div>
              </div>
              <div className="flex items-center gap-6" data-id="element-2656">
                <div className="text-sm font-mono text-[#FAFAFA]" data-id="element-2657">
                  {inv.amount}
                </div>
                <span className="inline-flex items-center gap-1.5 text-xs text-[#D4FF3A]" data-id="element-2658">
                  <Check className="h-3 w-3" data-id="element-2659" /> {inv.status}
                </span>
                <button className="p-1.5 rounded text-[#9A9A9A] hover:text-[#FAFAFA] hover:bg-[#262626] transition" data-id="element-2660">
                  <Download className="h-4 w-4" data-id="element-2661" />
                </button>
              </div>
            </li>)}
        </ul>
      </div>
    </div>;
}
export function SettingsNotifications() {
  const [prefs, setPrefs] = useState({
    anomalies_email: true,
    anomalies_push: true,
    returns_email: true,
    returns_push: false,
    reports_email: true,
    reports_push: false
  });
  const toggle = (key: keyof typeof prefs) => {
    setPrefs(p => ({
      ...p,
      [key]: !p[key]
    }));
  };
  return <div className="space-y-6 max-w-4xl" data-id="element-2662">
      <div data-id="element-2663">
        <h1 className="text-2xl font-semibold text-[#FAFAFA] font-heading tracking-tight" data-id="element-2664">
          Notifiche
        </h1>
        <p className="text-sm text-[#9A9A9A] mt-1" data-id="element-2665">
          Scegli quali notifiche ricevere e su quali canali.
        </p>
      </div>

      <div className="bg-[#181818] border border-[#262626] rounded-xl overflow-hidden" data-id="element-2666">
        <table className="w-full text-sm text-left" data-id="element-2667">
          <thead className="text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#262626] bg-[#0A0A0A]" data-id="element-2668">
            <tr data-id="element-2669">
              <th className="px-5 py-3 font-medium" data-id="element-2670">Tipo di notifica</th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-2671">
                <div className="flex flex-col items-center gap-1" data-id="element-2672">
                  <Mail className="h-4 w-4" data-id="element-2673" />
                  Email
                </div>
              </th>
              <th className="px-5 py-3 font-medium text-center w-24" data-id="element-2674">
                <div className="flex flex-col items-center gap-1" data-id="element-2675">
                  <Smartphone className="h-4 w-4" data-id="element-2676" />
                  Push
                </div>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#262626]" data-id="element-2677">
            <tr className="hover:bg-[#0A0A0A] transition-colors" data-id="element-2678">
              <td className="px-5 py-4" data-id="element-2679">
                <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2680">
                  Anomalie e ritardi
                </div>
                <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2681">
                  Notifiche immediate per problemi di consegna
                </div>
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2682">
                <input type="checkbox" checked={prefs.anomalies_email} onChange={() => toggle('anomalies_email')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2683" />
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2684">
                <input type="checkbox" checked={prefs.anomalies_push} onChange={() => toggle('anomalies_push')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2685" />
              </td>
            </tr>
            <tr className="hover:bg-[#0A0A0A] transition-colors" data-id="element-2686">
              <td className="px-5 py-4" data-id="element-2687">
                <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2688">
                  Richieste di reso
                </div>
                <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2689">
                  Nuovi resi aperti dai clienti
                </div>
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2690">
                <input type="checkbox" checked={prefs.returns_email} onChange={() => toggle('returns_email')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2691" />
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2692">
                <input type="checkbox" checked={prefs.returns_push} onChange={() => toggle('returns_push')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2693" />
              </td>
            </tr>
            <tr className="hover:bg-[#0A0A0A] transition-colors" data-id="element-2694">
              <td className="px-5 py-4" data-id="element-2695">
                <div className="text-sm font-medium text-[#FAFAFA]" data-id="element-2696">
                  Report settimanali
                </div>
                <div className="text-xs text-[#9A9A9A] mt-0.5" data-id="element-2697">
                  Sintesi delle performance dei corrieri
                </div>
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2698">
                <input type="checkbox" checked={prefs.reports_email} onChange={() => toggle('reports_email')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2699" />
              </td>
              <td className="px-5 py-4 text-center" data-id="element-2700">
                <input type="checkbox" checked={prefs.reports_push} onChange={() => toggle('reports_push')} className="h-4 w-4 rounded border-[#333] bg-[#0A0A0A] text-[#D4FF3A] focus:ring-[#D4FF3A]/30 focus:ring-offset-[#181818]" data-id="element-2701" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}